export { toggleSidebar } from './actions';
export init from './init';
export reducer, {initialState} from './reducer';
export Component from './components/Component';
export Container from './components/Container';
export MeSetting from './components/MeSetting';
export Register from './components/Register';
export Login from './components/Login';



/** WEBPACK FOOTER **
 ** ./src/app/modules/sidebar/index.js
 **/